module.exports = __webpack_public_path__ + "img/skip-button.1e20fc5c.png";